// TS types for live classes

/**
 * Enum containing all the possible modalities for Live classes
 */
export enum LiveClassModality {
  /**
   * Virtual training: A live instructor-led class offered as an online virtual conference.
   */
  VT = 'vt',
  /**
   * Instructor-led training: instructor-led training classes
   */
  ILT = 'ilt',
  /**
   * On-site
   */
  OS = 'os',
  OSVT = 'osvt',
  /**
   * Legacy???
   */
  LR = 'lr',
  PremVT = 'premvt', // ???? not sure
}

/** Live-class modalities plus exam (used by instructor dashboard class list filters). */
export type ClassListModality = LiveClassModality | 'exam';
// TODO: Adjust these types by adding optionals as needed
export type VtClass = {
  course_uuid: string;
  update_time: string;
  capacity: string; // Appears to be a string, e.g., "50"
  name: string;
  start_time: string;
  product: string;
  slug: string;
  course: {
    update_time: string;
    code: string;
    uuid: string;
    language: string;
    canonical: unknown;
    cformat: string;
    create_time: string;
    version: string;
    config: string;
    path: string;
    canonical_uuid: string;
    osversion: string;
    revision: string;
    name: string;
  };
  vtc_account: {
    access_key: string;
    profile: string;
    update_time: string;
    description: string;
    driver: string;
    region: string;
    tag: string;
    name: string;
    state: string;
    create_time: string;
    role: string;
    config: string; // Appears to be a string representation of an empty object "{}\n"
    uuid: string;
  };
  create_time: string;
  end_time: string;
  phase: string;
  extension_end_time: string;
  vtc_account_uuid: string;
  uuid: string;
};

/**
 * Legacy VT enrollment schema.
 */
export type EnrolledLiveClass = {
  // TODO: Maybe this type is just for VT and not all modalities?
  username: string;
  subscription: unknown;
  update_time: string;
  slug_tag: string;
  uuid: string;
  level: string;
  start_time: string;
  number: string;
  subscription_uuid: string;
  vtclass_uuid: string;
  token: string;
  create_time: string;
  role: string;
  end_time: string;
  etype: string;
  vtclass: VtClass;
  email: string;
  issubscription: string; // Appears to be a string, e.g., "False"
  name: string;
  lms_offering_id?: string;
  lms_offering_slug?: string;
};

interface StatusTransitionLog {
  new_status: string;
  orig_status: string;
  origin: string;
  timestamp: string;
}

interface LmsSyncMessage {
  errorCode: number;
  errorMessage: string;
}

export type LmsClassEnrollment = {
  '@timestamp': string;
  doc_id: string;
  doc_type: 'lms_class_enrollment';
  email?: string;
  endDate: string;
  entitlement_id?: string;
  fullName?: string;
  lms_sync_message?: LmsSyncMessage[] | string;
  lms_sync_state?: string;
  modifiedDate: string;
  offering: string;
  offeringId: number;
  offeringType: string;
  ole_status?: string;
  ole_sync_time?: string;
  origin?: string;
  startDate: string;
  status: string;
  statusCode: string;
  status_transition_log?: StatusTransitionLog[];
  userId?: number;
  userName: string;
  user_modality?: string;
  user_sub_modality?: string;
  user_uuid?: string;
};
